import axios from 'axios';
import utils from '@/utils/utils';

export function buildAuthConfig(accessToken) {
  return accessToken ? utils.getAuthorizeAxiosConfig(accessToken) : null;
}

export function withHeaders(config) {
  if (!config || !config.headers) return {};
  return { headers: config.headers };
}

export function getApiUrl(apiUrl) {
  return apiUrl;
}

export { axios };
